<app-header [progress]="2" [title]="locale.currentTranslation.accidentDescriptionHeader" data-testid="car-parts-involved-header"></app-header>
<div class="base-content-container" data-testid="car-parts-involved-container">
  <div class="headline3" data-testid="car-parts-involved-title">{{ locale.currentTranslation.carPartsInvolved1 }}
  </div>
  <form [formGroup]="optionsForm" data-testid="car-parts-form">
    <div style="display: flex; flex-direction: column; gap: 24px;" formArrayName="selectedOptions" data-testid="checkbox-options">
      @for (option of options; track option; let i = $index) {
        <label class="radio-button-base" [attr.data-testid]="'checkbox-option-' + option.value">
          <div>
            <input type="checkbox"
                   [value]="option.value"
                   [checked]="isSelected(option.value)"
                   (change)="setOption($event)"
                   [attr.data-testid]="'checkbox-input-' + option.value"
                   [attr.aria-label]="option.headline"
            >
          </div>
          <div>
            <div class="label1" [attr.data-testid]="'checkbox-label-' + option.value">{{ option.headline }}</div>
          </div>
        </label>
      }
    </div>
  </form>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button (click)="nextClicked()" class="main-button" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="car-parts-involved-footer"></app-footer>
